
























































































import Vue from 'vue'
import Component from 'vue-class-component'
import CreateLinkPopup from '@/components/Brand/CreateLinkPopup.vue'
import DeleteLinkPopup from '@/components/Brand/DeleteLinkPopup.vue'

@Component({
  components: {
    CreateLinkPopup,
    DeleteLinkPopup
  }
})
export default class Links extends Vue {
  public brandId = 0
  public links: any[] = []
  public busy = false
  public linkToDelete: any = null

  getLinks () {
    this.busy = true
    this.$http.get(`brands/${this.brandId}/links`).then((response: any) => {
      const body = response.body || {}
      this.links = Array.isArray(body.data) ? body.data : (Array.isArray(body.links) ? body.links : [])
      this.busy = false
    }, () => {
      this.busy = false
      this.links = []
    })
  }

  getLinkTypeLabel (linkType: string) {
    const labels: Record<string, string> = {
      'watch': 'Watch (video/short/story)',
      'app-install': 'App Install (apple/google play)',
      'review': 'Review (external link)'
    }
    return labels[linkType] || linkType || '—'
  }

  created () {
    this.brandId = this.$store.state.userData.brandId
    this.getLinks()
  }
}
